"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatSnapPublishTime = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_intl_1 = require("react-intl");
const PLAYER_TIME_TEN_SECONDS_SECS = 10;
const PLAYER_TIME_ONE_MINUTE_SECS = 60;
const PLAYER_TIME_ONE_HOUR_SECS = 3600;
const PLAYER_TIME_ONE_DAY_SECS = 86400;
const PLAYER_TIME_ONE_WEEK_SECS = 604800;
const PLAYER_TIME_ONE_YEAR_SECS = 31536000;
const formatSnapPublishTime = (timestampInSec) => {
    const nowInSec = new Date().getTime() / 1000;
    const diffInSec = nowInSec - timestampInSec;
    // Just now
    if (diffInSec < PLAYER_TIME_TEN_SECONDS_SECS) {
        return ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "LnWDDv", description: "timestamp text for Just now", defaultMessage: "Just now" }));
    }
    // 25m ago
    if (diffInSec < PLAYER_TIME_ONE_HOUR_SECS) {
        return ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "Daodtv", description: "timestamp text for minutes ago", defaultMessage: "{timeDifference}m ago", values: {
                timeDifference: Math.floor(diffInSec / PLAYER_TIME_ONE_MINUTE_SECS).toString(),
            } }));
    }
    // 3h ago
    if (diffInSec < PLAYER_TIME_ONE_DAY_SECS) {
        return ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "/r7Bc4", description: "timestamp text for hours ago", defaultMessage: "{timeDifference}h ago", values: {
                timeDifference: Math.floor(diffInSec / PLAYER_TIME_ONE_HOUR_SECS).toString(),
            } }));
    }
    // Fri
    if (diffInSec < PLAYER_TIME_ONE_WEEK_SECS) {
        return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedDate, { value: timestampInSec * 1000, weekday: "short" });
    }
    // 3 Jun
    if (diffInSec < PLAYER_TIME_ONE_YEAR_SECS) {
        return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedDate, { value: timestampInSec * 1000, month: "short", day: "numeric" });
    }
    // 3 Jun 2020
    return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedDate, { value: timestampInSec * 1000, month: "short", day: "numeric", year: "numeric" });
};
exports.formatSnapPublishTime = formatSnapPublishTime;
//# sourceMappingURL=publishTime.js.map